export default function Wordmark() {
  return (
    <div className="flex items-center gap-2">
      <img src="/logo-small.svg" alt="" className="h-6 w-auto" />
      <span className="text-base font-semibold">Pulsar</span>
      <span className="text-carbon-300 text-base">·</span>
      <span className="text-carbon-500 text-sm font-medium">Economics</span>
    </div>
  );
}
